// 复制指令
import { message } from 'ant-design-vue';
const copyDirective = {
    mounted(el, binding) {
        handleClick(el,binding);
    },
    updated(el, binding) {
        handleClick(el,binding)
    },
    beforeUnmount(el) {
        if (el.__handleClick__) {
            el.removeEventListener('click', el.__handleClick__)
        }
    }
}

const handleClick = (el,binding) => {
    // 如果值更新，则重新绑定
    if (el.__handleClick__) {
        el.removeEventListener('click', el.__handleClick__)
    }
    el.__handleClick__ = async () => {
        try {
            await navigator.clipboard.writeText(String(binding.value))
            if (binding.value) {
                console.log(String(binding.value))
                message.success(`[ ${String(binding.value)} ] 已复制到剪切版`);
            }
        } catch (error) {
            console.error('复制失败:', error)
            message.error('复制失败，请稍后再试')
        }
    }

    el.addEventListener('click', el.__handleClick__)
}

export default copyDirective